import { Component, OnInit } from "@angular/core";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Location } from "src/app/models/Location";
import { Tool } from "src/app/models/Tool";
import { ToolUpdate } from "src/app/models/ToolUpdate";
import { CompanyService } from "src/app/services/company.service";
import { LocationService } from "src/app/services/location.service";

import { ModalComponent, ModalService } from "../../services/modal.service";
import { ToolService } from "./../../services/tool.service";

@Component({
  selector: "location-modal",
  templateUrl: "./location-modal.component.html",
  styleUrls: ["./location-modal.component.scss"],
  standalone: false,
})
export class LocationModalComponent
  implements OnInit, ModalComponent<LocationModalComponent, Tool>
{
  faSpinner = faSpinner;
  isLoading: boolean;
  locations: Location[];

  constructor(
    private locationService: LocationService,
    private toolService: ToolService,
    public modalService: ModalService,
    private companyService: CompanyService,
    @Inject(MAT_DIALOG_DATA) public data: Tool,
    public dialogRef: MatDialogRef<LocationModalComponent, void>,
  ) {}

  ngOnInit() {
    if (!this.data) return;

    this.getLocations();
  }

  /**
   * Gets location name and description for location options
   */
  getLocations() {
    this.locationService
      .getList(this.data.companyId, this.companyService.selectedCompany.department.name)
      .subscribe((response) => {
        if (!response) {
          return;
        }

        this.locations = response;
      });
  }

  /**
   * Updates the location of the given location.
   * @param locationName
   */
  updateLocation(locationName) {
    this.isLoading = true;
    this.toolService
      .updateLocation(
        this.data.companyId,
        this.data.serialNumber,
        new ToolUpdate({
          locationName: locationName,
        }),
      )
      .subscribe(
        () => {
          const l = this.locations.find((l) => l.locationName === locationName);
          this.data.locationName = l?.locationName;
          this.data.locationDescription = l?.locationDescription;

          this.isLoading = false;
          this.modalService.close();
        },
        () => (this.isLoading = false),
      );
  }
}
